import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'

const createDataAttribtues = refinement =>
  Object.keys(refinement)
    .map(key => `data-${key}="${refinement[key]}"`)
    .join(' ')

const renderRefinementList = (introText, optionsSelector, extraClass, refinements) => {
  return introText + refinements.map(refinement => {
    const displayLabel = $(optionsSelector + ' option[value="' + refinement.value + '"]').data('title') || refinement.label
    return `
      <span class="c-tag c-tag--in-text ${extraClass}">
        ${displayLabel}
        <button class="c-tag__button" ${createDataAttribtues(refinement)}>
          <svg class="c-tag__button-icon c-svg-icon">
            <use xlink:href="/_resources/themes/default/images/icons/icons.svg#icon-cross"></use>
          </svg>
        </button>
      </span>
    `
  })
}

const renderTypeList = renderRefinementList.bind(this, ' within ', '#type-options', 'c-tag--content-type')
const renderTagList = renderRefinementList.bind(this, ' related to ', '#tag-options', '')

const renderCurrentRefinements = (renderOptions) => {
  const { items, widgetParams, refine } = renderOptions
  const container = document.querySelector(widgetParams.container)
  const selectedType = items.find(i => i.attribute === 'objectContentType')
  const selectedTags = items.find(i => i.attribute === 'objectTags')
  const typeHtml = selectedType && selectedType.refinements ? renderTypeList(selectedType.refinements) : ''
  const tagsHtml = selectedTags && selectedTags.refinements ? renderTagList(selectedTags.refinements) : ''
  container.innerHTML = typeHtml + tagsHtml;

  [...container.querySelectorAll('button')].forEach(element => {
    element.addEventListener('click', event => {
      const item = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      )

      refine(item)
    })
  })
}

const customCurrentRefinements = connectCurrentRefinements(
  renderCurrentRefinements
)

export default customCurrentRefinements
